let width: Ref<number> = ref(0)
let height: Ref<number> = ref(0)
let pixelRatio: number = 1
export default function useSizes() {
  if (import.meta.client && width.value === 0 && height.value === 0) {
    pixelRatio = Math.min(window.devicePixelRatio, 2)
  }

  function resize(_width?: number, _height?: number) {
    // console.log("resize")
    // console.log(_width, _height)

    width.value = _width || 600
    height.value = _height || 800
    pixelRatio = Math.min(window.devicePixelRatio, 2)
  }

  return {
    width,
    height,
    pixelRatio,
    resize,
  }
}
